// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.air-datepicker-cell.-year-.-other-decade-, .air-datepicker-cell.-day-.-other-month- {
  color: var(--adp-color-other-month);
}
.-disabled-.-focus-.air-datepicker-cell.-year-.-other-decade-, .-disabled-.-focus-.air-datepicker-cell.-day-.-other-month- {
  color: var(--adp-color-other-month);
}
.-selected-.air-datepicker-cell.-year-.-other-decade-, .-selected-.air-datepicker-cell.-day-.-other-month- {
  color: #fff;
  background: var(--adp-background-color-selected-other-month);
}
.-selected-.-focus-.air-datepicker-cell.-year-.-other-decade-, .-selected-.-focus-.air-datepicker-cell.-day-.-other-month- {
  background: var(--adp-background-color-selected-other-month-focused);
}
.-in-range-.air-datepicker-cell.-year-.-other-decade-, .-in-range-.air-datepicker-cell.-day-.-other-month- {
  background-color: var(--adp-cell-background-color-in-range);
  color: var(--adp-color);
}
.-in-range-.-focus-.air-datepicker-cell.-year-.-other-decade-, .-in-range-.-focus-.air-datepicker-cell.-day-.-other-month- {
  background-color: var(--adp-cell-background-color-in-range);
}
.-in-range-.-disabled-.air-datepicker-cell.-year-.-other-decade-, .-in-range-.-disabled-.air-datepicker-cell.-day-.-other-month- {
  background-color: var(--adp-background-color);
}
.air-datepicker-cell.-year-.-other-decade-:empty, .air-datepicker-cell.-day-.-other-month-:empty {
  background: none;
  border: none;
}

/* -------------------------------------------------
    Datepicker cell
   ------------------------------------------------- */
.air-datepicker-cell {
  border-radius: var(--adp-cell-border-radius);
  box-sizing: border-box;
  cursor: pointer;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  z-index: 1;
  display: flex;
  width: 40px;
  height: 40px;
  justify-content: center;
  align-items: center;
}
.air-datepicker-cell.-focus- {
  background: var(--adp-cell-background-color-hover);
}
.air-datepicker-cell.-current- {
  color: var(--adp-color-current-date);
  background: var(--adp-background-color-hover);
}
.air-datepicker-cell.-current-::before {
  content: "";
  position: absolute;
  background: var(--sdk-global-theme-color);
  bottom: 4px;
  width: 6px;
  height: 6px;
  border-radius: 100%;
  flex-shrink: 0;
}
.air-datepicker-cell.-current-.-focus- {
  color: var(--adp-color);
}
.air-datepicker-cell.-current-.-in-range- {
  color: var(--adp-color-current-date);
}
.air-datepicker-cell.-disabled- {
  cursor: default;
  color: var(--adp-color-disabled);
}
.air-datepicker-cell.-disabled-.-focus- {
  color: var(--adp-color-disabled);
}
.air-datepicker-cell.-disabled-.-in-range- {
  color: var(--adp-color-disabled-in-range);
  background-color: var(--adp-background-color);
}
.air-datepicker-cell.-disabled-.-current-.-focus- {
  color: var(--adp-color-disabled);
}
.air-datepicker-cell.-in-range- {
  background: var(--adp-cell-background-color-in-range);
}
.air-datepicker-cell.-in-range-:hover {
  background: var(--adp-cell-background-color-in-range-hover);
}
.air-datepicker-cell.-range-from- {
  background-color: var(--adp-cell-background-color-in-range);
  border-radius: var(--adp-cell-border-radius);
}
.air-datepicker-cell.-range-to- {
  background-color: var(--adp-cell-background-color-in-range);
  border-radius: var(--adp-cell-border-radius);
}
.air-datepicker-cell.-range-to-.-range-from- {
  border-radius: var(--adp-cell-border-radius);
}
.air-datepicker-cell.-selected- {
  color: var(--sdk-global-white);
  border: none;
  background: var(--adp-cell-background-color-selected);
}
.air-datepicker-cell.-selected-.-current- {
  color: var(--sdk-global-white);
  background: var(--adp-cell-background-color-selected);
}
.air-datepicker-cell.-selected-.-focus- {
  background: var(--adp-cell-background-color-selected-hover);
}
.air-datepicker-cell.-month- {
  width: auto;
  height: auto;
  margin: 2px;
  border-radius: 4px !important;
}
.air-datepicker-cell.-year- {
  width: auto;
  height: auto;
  margin: 2px;
  border-radius: 4px !important;
}

/*  Day cell
   ------------------------------------------------- */
/*  Year cell
   ------------------------------------------------- */`, "",{"version":3,"sources":["webpack://./src/libs/air-date-picker/src/_objects.scss","webpack://./src/libs/air-date-picker/src/datepickerCell.scss"],"names":[],"mappings":"AAAA;EACE,mCAAA;ACCF;ADMI;EACE,mCAAA;ACJN;ADQE;EACE,WAAA;EACA,4DAAA;ACNJ;ADOI;EACE,oEAAA;ACLN;ADSE;EACE,2DAAA;EACA,uBAAA;ACPJ;ADSI;EACE,2DAAA;ACPN;ADSI;EACE,6CAAA;ACPN;ADYE;EACE,gBAAA;EACA,YAAA;ACVJ;;AAxBA;;sDAAA;AAIA;EACE,4CAAA;EACA,sBAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;AA0BF;AAzBE;EACE,kDAAA;AA2BJ;AAxBE;EACE,oCAAA;EACA,6CAAA;AA0BJ;AAzBI;EACE,WAAA;EACA,kBAAA;EACA,yCAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;AA2BN;AAzBI;EACE,uBAAA;AA2BN;AAxBI;EACE,oCAAA;AA0BN;AAtBE;EACE,eAAA;EACA,gCAAA;AAwBJ;AAtBI;EACE,gCAAA;AAwBN;AArBI;EACE,yCAAA;EACA,6CAAA;AAuBN;AAnBM;EACE,gCAAA;AAqBR;AAhBE;EACE,qDAAA;AAkBJ;AAhBI;EACE,2DAAA;AAkBN;AAdE;EACE,2DAAA;EACA,4CAAA;AAgBJ;AAdE;EACE,2DAAA;EACA,4CAAA;AAgBJ;AAbE;EACE,4CAAA;AAeJ;AAZE;EACE,8BAAA;EACA,YAAA;EACA,qDAAA;AAcJ;AAZI;EACE,8BAAA;EACA,qDAAA;AAcN;AAXI;EACE,2DAAA;AAaN;AAVE;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,6BAAA;AAYJ;AAVE;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,6BAAA;AAYJ;;AAPA;sDAAA;AASA;sDAAA","sourcesContent":["%otherMonth {\n  color: var(--adp-color-other-month);\n\n  &:hover {\n    // color: var(--adp-cell-background-color-in-range);\n  }\n\n  &.-disabled- {\n    &.-focus- {\n      color: var(--adp-color-other-month);\n    }\n  }\n\n  &.-selected- {\n    color: #fff;\n    background: var(--adp-background-color-selected-other-month);\n    &.-focus- {\n      background: var(--adp-background-color-selected-other-month-focused);\n    }\n  }\n\n  &.-in-range- {\n    background-color: var(--adp-cell-background-color-in-range);\n    color: var(--adp-color);\n\n    &.-focus- {\n      background-color: var(--adp-cell-background-color-in-range);\n    }\n    &.-disabled- {\n      background-color: var(--adp-background-color);\n    }\n  }\n\n\n  &:empty {\n    background: none;\n    border: none;\n  }\n}\n","@import \"./_objects\";\n\n/* -------------------------------------------------\n    Datepicker cell\n   ------------------------------------------------- */\n\n.air-datepicker-cell {\n  border-radius: var(--adp-cell-border-radius);\n  box-sizing: border-box;\n  cursor: pointer;\n  display: flex;\n  position: relative;\n  align-items: center;\n  justify-content: center;\n  z-index: 1;\n  display: flex;\n  width: 40px;\n  height: 40px;\n  justify-content: center;\n  align-items: center;\n  &.-focus- {\n    background: var(--adp-cell-background-color-hover);\n  }\n\n  &.-current- {\n    color: var(--adp-color-current-date);\n    background: var(--adp-background-color-hover);\n    &::before{\n      content: \"\";\n      position: absolute;\n      background: var(--sdk-global-theme-color);\n      bottom: 4px;\n      width: 6px;\n      height: 6px;\n      border-radius: 100%;\n      flex-shrink: 0;  \n    }\n    &.-focus- {\n      color: var(--adp-color);\n    }\n\n    &.-in-range- {\n      color: var(--adp-color-current-date);\n    }\n  }\n\n  &.-disabled- {\n    cursor: default;\n    color: var(--adp-color-disabled);\n\n    &.-focus- {\n      color: var(--adp-color-disabled);\n    }\n\n    &.-in-range- {\n      color: var(--adp-color-disabled-in-range);\n      background-color: var(--adp-background-color);\n    }\n\n    &.-current- {\n      &.-focus- {\n        color:var(--adp-color-disabled);\n      }\n    }\n  }\n\n  &.-in-range- {\n    background: var(--adp-cell-background-color-in-range);\n\n    &:hover {\n      background: var(--adp-cell-background-color-in-range-hover);\n    }\n  }\n\n  &.-range-from- {\n    background-color: var(--adp-cell-background-color-in-range);\n    border-radius: var(--adp-cell-border-radius);\n  }\n  &.-range-to- {\n    background-color: var(--adp-cell-background-color-in-range);\n    border-radius: var(--adp-cell-border-radius);\n  }\n\n  &.-range-to-.-range-from- {\n    border-radius: var(--adp-cell-border-radius);\n  }\n\n  &.-selected- {\n    color: var(--sdk-global-white);\n    border: none;\n    background: var(--adp-cell-background-color-selected);\n\n    &.-current- {\n      color: var(--sdk-global-white);\n      background: var(--adp-cell-background-color-selected);\n    }\n\n    &.-focus- {\n      background: var(--adp-cell-background-color-selected-hover);\n    }\n  }\n  &.-month-{\n    width: auto;\n    height: auto;\n    margin:2px;\n    border-radius: 4px !important;\n  }\n  &.-year-{\n    width: auto;\n    height: auto;\n    margin:2px;\n    border-radius: 4px !important;\n  }\n}\n\n\n/*  Day cell\n   ------------------------------------------------- */\n\n.air-datepicker-cell.-day- {\n  &.-other-month-{\n    @extend %otherMonth;\n  }\n}\n\n/*  Year cell\n   ------------------------------------------------- */\n\n.air-datepicker-cell.-year- {\n  &.-other-decade-{\n    @extend %otherMonth;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
